/**
 * 🚨 GENERATED FILE - DO NOT EDIT DIRECTLY
 * Source: /project_config.json
 */
export const ENDPOINTS = {
  login: '/api/auth/login',
  register: '/api/auth/register',
  logout: '/api/auth/logout',
  setup_status: '/api/setup/status',
  channels: '/api/channels',
  voice_state: '/api/voice/state',
  admin_stats: '/api/admin/stats',
  admin_users: '/api/admin/users',
  admin_channels: '/api/admin/channels',
};
